import { Route, Routes } from "react-router";

import { CustomerSupportPage } from "../team/pages/CustomerSupportPage";
import { CustomerListPage } from "./pages/CustomerListPage";
import { CustomerMemoryPage } from "./pages/CustomerMemoryPage";
import { MemoryFactPage } from "./pages/MemoryFactPage";

/**
 * The customer routes, mounted at `/customers/*` (CHT-721):
 *   /customers                                        the customers the staff member may open
 *   /customers/:customerId                            the support view of one customer (CHT-768)
 *   /customers/:customerId/memory                     the memory workspace of one customer
 *   /customers/:customerId/memory/facts/:factId       one memory: evidence, chain, audit trail
 */
export function CustomersRoutes() {
  return (
    <Routes>
      <Route index element={<CustomerListPage />} />
      <Route path=":customerId" element={<CustomerSupportPage />} />
      <Route path=":customerId/memory" element={<CustomerMemoryPage />} />
      <Route path=":customerId/memory/facts/:factId" element={<MemoryFactPage />} />
    </Routes>
  );
}
